/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_No_Members_Yet_Description_MemberInputs */



/**
* | output |
* | --- |
* | "Contact an administrator to add members." |
*
* @param {Members_No_Members_Yet_Description_MemberInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_no_members_yet_description_member = /** @type {((inputs?: Members_No_Members_Yet_Description_MemberInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_No_Members_Yet_Description_MemberInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontaktiere einen Administrator, um Mitglieder hinzuzufügen.")
	return /** @type {LocalizedString} */ ("Contact an administrator to add members.")
});